import { SVGProps } from 'react';

export const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={24}
    width={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7233 0.93747L14.7243 0.938299L22.4001 7.19227C22.9837 7.67123 23.4163 8.36791 23.6799 9.07222C23.9439 9.7774 24.0752 10.5881 23.9553 11.3366L23.9548 11.3399L22.4818 20.325L22.4813 20.3278C22.1435 22.3502 20.253 23.9997 18.204 23.9997H5.79975C3.74054 23.9997 1.85979 22.3622 1.52224 20.3267L0.0498896 11.3455L0.0493787 11.3425C-0.0777202 10.5915 0.051026 9.77876 0.315506 9.07222C0.579938 8.3658 1.01643 7.66851 1.60678 7.18972L1.60817 7.18859L9.28021 0.92635C10.7956 -0.311774 13.2 -0.309482 14.7233 0.93747ZM13.5544 2.36645C12.7077 1.67284 11.2807 1.67565 10.4485 2.35582L2.77292 8.62093L2.77029 8.62307C2.49747 8.84409 2.22563 9.23553 2.04449 9.71943C1.86354 10.2028 1.80954 10.6813 1.86986 11.0357L1.87081 11.0413L3.34352 20.0247C3.53794 21.1946 4.66954 22.1536 5.79975 22.1536H18.204C19.3221 22.1536 20.4656 21.1851 20.6602 20.025L20.6604 20.0236L22.1324 11.0446L22.1327 11.043C22.1895 10.6855 22.1325 10.2044 21.9509 9.71943C21.769 9.23351 21.4988 8.84131 21.23 8.62026L21.2289 8.61938L13.5563 2.36799L13.5544 2.36645Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15C12.5523 15 13 15.3998 13 15.8929V19.1071C13 19.6002 12.5523 20 12 20C11.4477 20 11 19.6002 11 19.1071V15.8929C11 15.3998 11.4477 15 12 15Z"
    />
  </svg>
);
